import { render, staticRenderFns } from "./ExhibitionDetail.vue?vue&type=template&id=4bf7c3ea&scoped=true"
import script from "./ExhibitionDetail.vue?vue&type=script&lang=js"
export * from "./ExhibitionDetail.vue?vue&type=script&lang=js"
import style0 from "./ExhibitionDetail.vue?vue&type=style&index=0&id=4bf7c3ea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf7c3ea",
  null
  
)

export default component.exports